<template>
    <div :style="cssProps">
        <label class="form-checkbox" :style="cursor">
          <span class="checkmark">
              <input
                v-if="Array.isArray(checked)"
                @input="emitEventArray"
                @click="$emit('click')"
                :disabled="disable || (value === checked[0] && obligatory)"
                type="checkbox"
                ref="check"
                :value="valueData"
                :checked="checkedData.includes(valueData)"
              >
              <input
                v-else
                @input="emitEvent"
                @click="$emit('click')"
                :disabled="disable"
                ref="check"
                type="checkbox"
                :value="valueData"
                :checked="checkedData"
              >
              <icon class="check-icon"  :style="error && !disable ? { 'border-color': errorColorData, cursor } : { textStyle, cursor }" :class="{ 'rounded': rounded, 'transparent--text': !isChecked, 'white--text': isChecked }" name="check" :size="16" />
          </span>
          <span class="checkbox-text">
            <slot name="text">
            </slot>
          </span>
        </label>
    </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B1D34B',
      required: false
    },
    text: {
      type: String,
      default: '',
      required: false
    },
    checked: {
      required: false
    },
    value: {
      default: false,
      required: false
    },
    rounded: {
      type: Boolean,
      default: false,
      required: false
    },
    disable: {
      type: Boolean,
      default: false,
      required: false
    },
    textColor: {
      type: String,
      default: 'black'
    },
    error: {
      type: Boolean,
      default: false
    },
    obligatory: {
      type: Boolean,
      default: false
    },
    single: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  data () {
    return {
      valueData: this.value,
      checkedData: this.checked,
      borderColorData: '#CCCCCC',
      textColorData: '#9e9e9e',
      errorColorData: 'rgba(255, 0, 0, 0.5)',
      backgroundColorData: 'white',
      textStyle: {
        color: 'rgb(112, 112, 112)'
      }
    }
  },
  methods: {
    emitEventArray () {
      let checked = [].concat(this.checked)
      if (this.single) {
        this.$emit('input', [this.value])
      } else {
        let index = checked.indexOf(this.value)
        if (index > -1) {
          checked.splice(index, 1)
        } else {
          checked.push(this.value)
        }
        this.$emit('input', checked)
      }
    },
    emitEvent () {
      if (this.error) {
        this.borderColorData = 'rgb(112, 112, 112)'
        this.textStyle.color = '#CCCCCC'
      }
      this.checkedData = !this.checked
      if (this.checkedData) {
        this.backgroundColorData = this.color
      } else {
        this.backgroundColorData = 'white'
      }
      this.$emit('input', this.checkedData)
      this.$emit('click')
    },
    validate () {
      if (this.checked) {
        this.error = false
        return true
      } else {
        this.error = true
        this.borderColorData = this.errorColorData
        this.textStyle.color = this.errorColorData
        return false
      }
    }
  },
  watch: {
    checked () {
      this.checkedData = this.checked
    },
    value () {
      this.valueData = this.value
    }
  },
  computed: {
    isChecked () {
      return Array.isArray(this.checked) ? (this.checked[0]) : this.checked
    },
    cursor () {
      return this.disable ? { 'cursor': 'not-allowed !important' } : { 'cursor': 'pointer !important' }
    },
    cssProps () {
      return {
        '--background-color': this.backgroundColorData,
        '--border-color': this.error ? this.errorColorData : this.borderColorData
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$corText: #60656C
$corBorda: #EBEBEB
$corBotaoAtivo: #00995D
$corTexto: #9E9E9E
$corBordarPaginacao: #9E9E9E
$corBorda: #CCCCCC
$corSelected: #F1F2F166

.form-checkbox
  display: block
  line-height: 1.2rem
  margin: .1rem 0
  min-height: 1.4rem
  padding: .1rem .2rem .1rem 0.2rem
  position: relative

.form-checkbox input
  clip: rect(0, 0, 0, 0)
  height: 1px
  margin: -1px
  overflow: hidden
  position: absolute
  width: 1px

.form-checkbox input:checked + .check-icon
  background: $corBotaoAtivo
  border-color: $corBotaoAtivo

.form-checkbox .check-icon
  border: 2px solid $corBorda
  border-radius: 4px
  display: inline-block
  position: absolute
  transition: background .2s,border .2s,box-shadow .2s,color .2s

.form-checkbox .check-icon
  background: transparent
  height: 19px
  width: 19px
  left: 0
  top: .3rem

.checkmark
  display: inline-block
  margin-right: 6px
  width: 16px
  height: 16px
  border-color: (--va)

.checkmark input:checked ~ .check-icon:after
  transition: display .2s
  display: block

.checkbox-text
  display: inline-block
  position: relative
  top: 2px
  -webkit-user-select: none
  -moz-user-select: none
  -ms-user-select: none
  user-select: none

.rounded
  background: white !important
  border-radius: 50px !important
  &:after
    content: ""
    display: none
    position: absolute
    top: 4px
    left: 4px
    width: 7px
    height: 7px
    border-radius: 50%
    background: $corBotaoAtivo
</style>
